import { SVGProps } from "react";
import { vars } from "~/styles/variables.css";

interface IProps extends SVGProps<SVGSVGElement> {}

export const SubtractMask = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 1640 79"
      {...props}
    >
      <path
        fill={vars.desktop.semanticsBrandThemeNeutral01Inv}
        d="M0 78.172V0h1640v4.732z"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </svg>
  );
};
